<template>
	<div class="loginCom">
		<el-drawer v-model="drawer" :direction="direction" :before-close="handleClose" :size="drawerSize"
			:lock-scroll="true" :modal="true" :close-on-click-modal="true" :show-close="true" :with-header="false">
			<!-- <template #header>

			</template> -->
			<template #default>
				<div class="login_header">
					<div class="login_header_left">
						<img src="/assets/images/icon_logo.png" class="logo" @click="onHome" />
						<div class="round" />
						<span class="business-title">{{ $t('business_title') }}</span>
					</div>
					<i class="iconfont icon-icon_close" @click="loginClose"></i>
				</div>
				<div class="login_content">

					<div class="login_box">
						<loginView :isDrawer='openDrawerFlag'></loginView>
					</div>
					<div class="functional_Area hidden-xs-only hidden-sm-only">
						<span class="functional_Area_title">{{ $t('login_rights_title') }}</span>
						<functionalArea></functionalArea>
					</div>

				</div>
			</template>

		</el-drawer>
	</div>
</template>

<script setup lang='ts'>

 import { ref, reactive, watch } from "vue";
 import { useI18n } from "vue-i18n";
 const { t, locale } = useI18n();
import type { DrawerProps } from 'element-plus'
const functionalArea = defineAsyncComponent(() => import("@/components/loginComponents/functionalArea.vue"))
const loginView = defineAsyncComponent(() => import("@/components/loginComponents/loginView.vue"))

 import eventBus from "vue3-eventbus";
 import useUserStore from "@/store/modules/user";
 import useProStore from "@/store/modules/pro";
 import useBaseStore from "@/store/modules/basic";
 import {storeToRefs} from "pinia";
//  import { isMobileOrTablet } from "@/utils"

 const router = useRouter();
 const route = useRoute();
 const userStore = useUserStore();
 const userProStore = useProStore();
 const baseStore = useBaseStore();
 const { userInfo, token }  = storeToRefs(userStore);
 const { proConfig }  = storeToRefs(userProStore);
 const { languages, isChina}  = storeToRefs(baseStore);

const drawerSize  = ref('77%')
const direction = ref<DrawerProps['direction']>('rtl')
const drawer = ref(false)

const openDrawerFlag = ref(false);
// 包括遮罩和 Esc 关闭，及时同步登录弹层的打开状态。
watch(drawer, value => { openDrawerFlag.value = value }, { flush: 'sync' })

defineExpose({ loginOpen, loginClose })

function loginOpen() {
	openDrawer();
}
const emit = defineEmits(['close']);
function loginClose() {
	
	emit('close');
	// step.value = 1
	// onClearInput()
	// onCheck()
	closeDrawer()
	
	
}
const openDrawer = () => {
	drawer.value = true
	openDrawerFlag.value = true;
}
const closeDrawer = () => {
	drawer.value = false
	openDrawerFlag.value = false;
}
const handleClose = (done: () => void) => {
	done()
	emit('close')
}
const onHome = () => {
	navigate('/');
}
const navigate = (name) => {
	// 跳转页面前，关闭当前弹窗
	loginClose()
	router.push({
		path: name
	})
}

onMounted(() => {
	// if (process.client) {
	// 	if (isMobileOrTablet()) {
	// 		drawerSize.value = '100%'
	// 	} 
	// }
	window.addEventListener('resize', () => {
		if (window.innerWidth < 576) {
			drawerSize.value = '100%'
		} else {
			drawerSize.value = '77%'
		}
	})
})
</script>

<style scoped lang='scss'>
.login_header{
	position: relative;
	z-index: 2;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	i{
		font-size: 24px;
		cursor: pointer;
	}
	.login_header_left {
		display: flex;
		flex-direction: row;
		align-items: center;
		.logo{
			width: 242px;
			height: 44px;
		}
		.round {
			width: 8px;
			height: 8px;
			background: #262626;
			border-radius: 50%;
			margin: 0 20px;
		}
		.business-title {
			font-size: 30px;
			color: #262626;
			font-weight: bold;
		}
	}
}
.login_content{
	position: absolute;
	top:0;
	left:0;
	right:0;
	bottom:0;
	width: 100%;
	display: flex;
	justify-content: space-between;
	.functional_Area{
		background-color: #E5F2FB;
		width:300px;
		padding:140px 0 0 30px;
		.functional_Area_title {
			font-size: 14px;
			color: #5C7AB0;
			font-weight: bold;
		}
		img{
			width:40px;
			height:18px;
			// margin-bottom: 10px;
		}

	}
	.login_box{
		padding-top: 130px;
		flex: 1;
	}
}

</style>
